import { UAE_COUNTRY_CODE } from '../../../constants/defaults';
import { mapPartyIdentificationForSubmit } from '../../../utils/partyIdentificationSubmit';

/**
 * Builds the PUT /business-profiles/:profile_id body (BusinessProfileUpdateRequest).
 * profile_id is included for routing only; strip before sending as JSON body.
 */
export function buildBusinessProfileUpdatePayload(formData, { profileId, logoUrl }) {
  const payload = {
    profile_id: profileId,
    name: formData.name,
    logo_url: logoUrl,
    scheme_agency_id: formData.scheme_agency_id?.code,
    company_id: formData.company_id,
    telephone: formData.telephone,
    postal_address: {
      street_name: formData.postal_address?.street_name,
      additional_street_name: formData.postal_address?.additional_street_name ?? '',
      address_line: formData.postal_address?.address_line ?? '',
      city_name: formData.postal_address?.city_name,
      postal_zone: formData.postal_address?.postal_zone,
      country_code: UAE_COUNTRY_CODE,
      country: formData.postal_address?.country_code?.label,
      country_subentity: formData.postal_address?.country_subentity?.code ?? '',
    },
  };

  if (formData.scheme_agency_id?.code === 'TL') {
    payload.authority_name = formData.authority_name ?? '';
  }

  if (formData.scheme_agency_id?.code === 'PAS') {
    payload.passport_issuing_country_code = formData.passport_issuing_country_code?.code;
  }

  const partyIdentification = mapPartyIdentificationForSubmit(formData);
  payload.party_identification_id = partyIdentification.party_identification_id;
  payload.party_identification_scheme_id = partyIdentification.party_identification_scheme_id;

  return payload;
}
